/**
 * Created by vladislav on 9/6/2022
 */

const CleverApps = function () {
    PortalBase.call(this, connector.CLEVERAPPS);
};

CleverApps.prototype = Object.create(PortalBase.prototype);
CleverApps.prototype.constructor = CleverApps;

CleverApps.prototype.getLocalStoragePrefix = function () {
    return "_cleverapps";
};
